const DISMISS_STORAGE_KEY = 'site_notice_dismissed_id'

export function getDismissedSiteNoticeId(): string | null {
  try {
    return localStorage.getItem(DISMISS_STORAGE_KEY)
  } catch {
    return null
  }
}

export function dismissSiteNotice(noticeId: string): void {
  try {
    localStorage.setItem(DISMISS_STORAGE_KEY, noticeId)
  } catch {
    // Private browsing / storage blocked — banner stays visible for the session.
  }
}

export function isSiteNoticeDismissed(noticeId: string): boolean {
  return getDismissedSiteNoticeId() === noticeId
}
